import type { FunctionComponent } from 'react';

import { LegalDataCommons } from '@/retention/Footer/modules/LegalData/components/LegalDataCommons';

export const LegalData: FunctionComponent = () => {
  return <LegalDataCommons />;
};

LegalData.displayName = 'LegalData';
